const { createClient } = require('@supabase/supabase-js');


const supabaseAdmin = createClient(
  'https://sqhwzpezrcxrlhmiaxhk.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNxaHd6cGV6cmN4cmxobWlheGhrIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc0OTI5ODc0NCwiZXhwIjoyMDY0ODc0NzQ0fQ.mUlaspoiPthNarbXJq7UeBN6ePKiS1PZ6h1qwdy5bVw', {
    auth: {
        persistSession: true,
        autoRefreshToken: true
    }
  }
);

const supabaseAnon = createClient(
  'https://sqhwzpezrcxrlhmiaxhk.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNxaHd6cGV6cmN4cmxobWlheGhrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDkyOTg3NDQsImV4cCI6MjA2NDg3NDc0NH0.l25iFTtp1228Q6KK0IpluMUH6B39vUzTik7NvLJHMhk', {
    auth: {
        persistSession: true,
        autoRefreshToken: true
    }
  }
);


module.exports = { supabaseAdmin, supabaseAnon }; 